import PropTypes from 'prop-types'
import Link from 'components/link'
import { WeekByWeekGuideCard } from 'components/card'
import { feedGuideViewerPath } from 'lib/urls'

const WeekByWeekCard = ({ postUrl, imageUrl, gradient, teaser, title }) => {
  return (
    <Link to={feedGuideViewerPath(postUrl)} routerVersion={4}>
      <WeekByWeekGuideCard
        imageUrl={imageUrl}
        gradient={gradient}
        postUrl={postUrl}
        title={title}
        teaser={teaser}
      />
    </Link>
  )
}

WeekByWeekCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  gradient: PropTypes.string,
  postUrl: PropTypes.string.isRequired,
  teaser: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default WeekByWeekCard
